import Head from "next/head";
import { useEffect } from "react";

export default function StaticRedirect({ destination }: { destination: string }) {
  useEffect(() => {
    window.location.replace(destination);
  }, [destination]);

  return (
    <>
      <Head>
        <meta httpEquiv="refresh" content={`0;url=${destination}`} />
        <meta name="robots" content="noindex,follow" />
        <link rel="canonical" href={`https://www.chesshotel.com${destination}`} />
      </Head>
      <main className="flex min-h-[40vh] items-center justify-center p-6">
        <a className="text-altblue-600 underline" href={destination}>
          Continue
        </a>
      </main>
    </>
  );
}
